// Koordinatensuche mit WGS84 und UTM32, sowie Beschränkung auf Thüringen
function coordinatesSearchTh(text, searchParams, callback) {
    const displaycrs = searchParams.displaycrs || "EPSG:4326";
    const matches = text.match(/^\s*([+-]?\d+\.?\d*)[,\s]\s*([+-]?\d+\.?\d*)\s*$/);
    const items = [];
    if (matches && matches.length >= 3) {
        const x = parseFloat(matches[1]);
        const y = parseFloat(matches[2]);
        // UTM-Koordinaten
        if (displaycrs !== "EPSG:4326" && x >= 560000 && x <= 760000 && y >= 5560000 && y <= 57250000) {
            items.push({
                id: "coord0",
                text: x + ", " + y + " (ETRS89 / UTM 32N)",
                x: x,
                y: y,
                crs: displaycrs,
                bbox: [x, y, x, y]
            });
        }
        // UTM aber x und y vertauscht
        if (displaycrs !== "EPSG:4326" && x >= 5560000 && x <= 57250000 && y >= 560000 && y <= 760000 ) {
            items.push({
                id: "coord0",
                text: y + ", " + x + " (ETRS89 / UTM 32N)",
                x: y,
                y: x,
                crs: displaycrs,
                bbox: [y, x, y, y]
            });
        }
        // geographische Eingabe Länge, Breite
        if (x >= 9 && x <= 13 && y >= 50 && y <= 52) {
            const title = Math.abs(x) + (x >= 0 ? "°E" : "°W") + ", "
                      + Math.abs(y) + (y >= 0 ? "°N" : "°S");
            items.push({
                id: "coord" + items.length,
                text: title,
                x: x,
                y: y,
                crs: "EPSG:4326",
                bbox: [x, y, x, y]
            });
        }
        // Eingabe Breite, Länge (z.B. aus GoogleMaps))
        if (x >= 50 && x <= 52 && y >= 9 && y <= 13 && x != y) {
            const title = Math.abs(y) + (y >= 0 ? "°E" : "°W") + ", "
                      + Math.abs(x) + (x >= 0 ? "°N" : "°S");
            items.push({
                id: "coord" + items.length,
                text: title,
                x: y,
                y: x,
                crs: "EPSG:4326",
                bbox: [y, x, y, x]
            });
        }
    }
    const results = [];
    if (items.length > 0) {
        results.push(
            {
                id: "coords",
                titlemsgid: "Koordinaten",
                items: items
            }
        );
    }
    callback({results: results});
}

/** ************************************************************************ **/

window.QWC2SearchProviders = {
    coordinates_th: {
        labelmsgid: "coordinates",
        onSearch: coordinatesSearchTh,
        handlesGeomFilter: false
    }
};
